var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.78952 0C2.78447 0 1.8206 0.380316 1.10992 1.05728C0.399252 1.73425 0 2.65242 0 3.60979V20.4555C0 21.4129 0.399252 22.331 1.10992 23.008C1.8206 23.685 2.78447 24.0653 3.78952 24.0653H11.3685C12.3736 24.0653 13.3375 23.685 14.0481 23.008C14.7588 22.331 15.1581 21.4129 15.1581 20.4555V3.60979C15.1581 2.65242 14.7588 1.73425 14.0481 1.05728C13.3375 0.380316 12.3736 0 11.3685 0H3.78952ZM16.7913 6.36888C17.0282 6.1433 17.3495 6.01658 17.6844 6.01658C18.0194 6.01658 18.3406 6.1433 18.5775 6.36888L23.6302 11.1819C23.867 11.4076 24 11.7136 24 12.0326C24 12.3517 23.867 12.6577 23.6302 12.8833L18.5775 17.6964C18.3392 17.9156 18.0202 18.0369 17.689 18.0341C17.3578 18.0314 17.0409 17.9048 16.8067 17.6817C16.5725 17.4586 16.4397 17.1569 16.4368 16.8414C16.4339 16.5259 16.5612 16.2219 16.7913 15.995L19.6878 13.2359H8.84221C8.50719 13.2359 8.1859 13.1091 7.94901 12.8835C7.71212 12.6578 7.57903 12.3518 7.57903 12.0326C7.57903 11.7135 7.71212 11.4075 7.94901 11.1818C8.1859 10.9561 8.50719 10.8294 8.84221 10.8294H19.6878L16.7913 8.07029C16.5545 7.84464 16.4215 7.53864 16.4215 7.21958C16.4215 6.90052 16.5545 6.59452 16.7913 6.36888Z",
    fill: "#3B4B70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.6301d29d1f876fb6dbf280ea0d9751e0.svg";
export { ForwardRef as ReactComponent };